var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('span',{attrs:{"id":"hiddenbtn","hidden":""}},[_vm._v("clipboard btn")]),_c('v-icon-selector',{attrs:{"page-size":70},on:{"selectIcon":_vm.onSelectIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }